<template>
  <div></div>
</template>

<script>
import UserAPI from "@/services/UserAPI";
export default {
  name: "PendoTracker",
  created() {

    // Check if this is a standalone external route to avoid profile API calls
    const route = this.$route;
    const isStandaloneExternal = (route.params.standalone === 'standalone' && route.params.external === 'external') 
                               || (route.path && route.path.includes('/standalone/external/'));
    
    if (isStandaloneExternal) {
      console.log('PendoTracker: Skipping profile API call for standalone external route');
      return;
    }
    
    let user_data;
    UserAPI.getUserProfileDetails().then((result) => {
      if (window.pendo && result) {
        user_data = result;
        pendo.initialize({
          visitor: {
            id: this.hash(user_data.user.username),
          },
          account: {
            id: user_data.customer_reference,
            bpm_organisationId: user_data.organisation_reference,
          },
        });
      }
    });
  },
  methods: {
    hash(email) {
      return this.fnv32a(email);
    },
    fnv32a(n) {
      for (var r = 2166136261, t = 0; t < n.length; ++t) {
        r ^= n.charCodeAt(t);
        r += (r << 1) + (r << 4) + (r << 7) + (r << 8) + (r << 24);
      }
      return r >>> 0;
    },
  },
};
</script>
